import * as RadixTabs from '@radix-ui/react-tabs';
import styled from 'styled-components';
import { body2Bold, body2Medium, colors, spacing, easing, borderRadius, duration } from 'ui/theme';

export const TabsGroup = RadixTabs.Root;
export const TabsContent = RadixTabs.Content;

export const IndexTabsList = styled(RadixTabs.List)`
  align-items: center;
  display: flex;
  gap: ${spacing.quarter};
  width: fit-content;
`;

export const IndexTabTrigger = styled(RadixTabs.Trigger)`
  all: unset;
  ${body2Medium}
  cursor: pointer;
  align-items: center;
  border-radius: ${borderRadius.full};
  color: ${colors.textPrimary};
  display: flex;
  justify-content: center;
  padding: ${spacing.threeQuarter} ${spacing.base};
  transition: all ${duration.short} ${easing.entrance};
  &:hover {
    background-color: ${colors.backgroundInteractive};
    color: ${colors.textLink};
  }
  &[data-state='active'] {
    background-color: ${colors.backgroundInteractiveStrong};
    color: ${colors.textOnColor};
  }
  &[disabled] {
    color: ${colors.textDisabled};
    cursor: not-allowed;
    &[data-state='active'] {
      background-color: ${colors.backgroundDisabledStrong};
      color: ${colors.textOnColor};
    }
    :not([data-state='active']) {
      background-color: transparent;
      color: ${colors.textDisabled};
    }
  }
`;

export const NavTabsList = styled(RadixTabs.List)`
  align-items: center;
  border-bottom: ${spacing.single} solid ${colors.borderPrimarySubtle};
  display: flex;
  gap: ${spacing.half};
  padding: ${spacing.threeQuarter} 0;
  width: fit-content;
`;

export const NavTabTrigger = styled(RadixTabs.Trigger)`
  all: unset;
  ${body2Bold}
  align-items: center;
  border-radius: ${borderRadius.full};
  color: ${colors.secondaryText};
  cursor: pointer;
  circle,
  path,
  rect {
    fill: ${colors.iconPrimary};
  }
  display: flex;
  position: relative;
  justify-content: center;
  padding: ${spacing.fiveEights} ${spacing.threeQuarter};
  transition: all ${duration.short} ${easing.entrance};

  &:hover {
    background-color: ${colors.backgroundTertiary};
    color: ${colors.textPrimary};
    circle,
    path,
    rect {
      fill: ${colors.textPrimary};
    }
    &[data-state='active'] {
      background-color: ${colors.backgroundInteractive};
    }
  }

  &[data-state='active'] {
    color: ${colors.textLink};
    circle,
    path,
    rect {
      fill: ${colors.backgroundInteractiveStrong};
    }
    :before {
      background-color: ${colors.backgroundInteractiveStrong};
      border-radius: ${borderRadius.full} ${borderRadius.full} 0px 0px;
      bottom: calc(-1 * (${spacing.threeQuarter} + ${spacing.single}));
      content: '';
      height: ${spacing.quarter};
      left: ${spacing.threeQuarter};
      position: absolute;
      right: ${spacing.threeQuarter};
    }
  }

  &[disabled]:not([data-state='active']) {
    color: ${colors.textDisabled};
    cursor: not-allowed;
    circle,
    path,
    rect {
      fill: ${colors.iconDisabled};
    }
    :hover {
      background-color: transparent;
    }
  }
`;

// Vertical Tabs

export const VerticalTabsList = styled(RadixTabs.List)`
  border-left: ${spacing.single} solid ${colors.borderPrimarySubtle};
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: 0;
  width: fit-content;
`;

export const VerticalTabTrigger = styled(RadixTabs.Trigger)`
  all: unset;
  ${body2Medium}
  align-items: center;
  border-radius: ${borderRadius.full};
  color: ${colors.secondaryText};
  cursor: pointer;
  display: flex;
  position: relative;
  justify-content: flex-start;
  padding: 0 0 0 ${spacing.threeQuarter};
  transition: all ${duration.short} ${easing.entrance};

  &:hover {
    color: ${colors.textPrimary};
  }

  &[data-state='active'] {
    color: ${colors.textLink};
  }

  &[disabled]:not([data-state='active']) {
    color: ${colors.textDisabled};
    cursor: not-allowed;
  }
`;
